import React from "react";
const Home = () => React.createElement("div", null);
export default Home;
